// extracted by mini-css-extract-plugin
export default {"button":"AuthErrorModal_button__OXIhf"};